import { IQuyCheActionTypes } from "../../action-types/category/IQuyCheActions";
import { IQuyCheReducer } from "../../reducer-model/category/IQuyCheReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IQuyCheReducer = {
    status: eReducerStatusBase.is_not_initialization,
    quyChes: [],   
}
export const quyCheReducer = (state: IQuyCheReducer = iniState, action: IQuyCheActionTypes): IQuyCheReducer => {
    switch (action.type) {
        case "QUY_CHE_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "QUY_CHE_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                quyChes: action.payload,
            };
        case "QUY_CHE_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "QUY_CHE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                quyCheEdit: action.payload,
            };
        case "QUY_CHE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "QUY_CHE_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "QUY_CHE_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "QUY_CHE_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "QUY_CHE_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "QUY_CHE_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "QUY_CHE_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}